import {isNewPasswordLength, NEW_PASSWORD_LENGTH_MESSAGE} from "../../../helpers/passwordRules.js";

export const validateUserName = (userName) => {
    if (!userName || !(userName.length >= 4 && userName.length <= 255))
        return 'UserName field should be between 4 and 255 characters long.';

    return '';
}

export const validateFirstName = (firstName) => {
    if (!firstName || !(firstName.length >= 1 && firstName.length <= 50))
        return 'First name field should be between 1 and 50 characters long.';

    if (!(/^[a-z\d\-_\s]+$/i.test(firstName)))
        return 'An incorrect character was entered into this field, allowable characters.  [a-z, A-Z, 0-9, space character and underscore are allowed]';

    return '';
}

export const validateLastName = (lastName) => {
    if (!lastName || !(lastName.length >= 1 && lastName.length <= 50))
        return 'Last name field should be between 1 and 50 characters long.';

    if (!(/^[a-z\d\-_\s]+$/i.test(lastName)))
        return 'An incorrect character was entered into this field, allowable characters.  [a-z, A-Z, 0-9, space character and underscore are allowed]';

    return '';
}

export const validateEmailAddress = (emailAddress) => {
    const mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!emailAddress || !(emailAddress.length <= 255))
        return 'Email address field should be between 1 and 255 characters long.';

    if (!emailAddress.match(mailFormat))
        return 'You must enter a valid email address.';

    return '';
}

export const validatePhoneNumber = (phoneNumber) => {
    // Use a regex that matches standard North American phone formats
    const phoneRegex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;

    // Convert to string only if phoneNumber is not null or undefined
    // Then check if it's empty or doesn't match the regex
    if (phoneNumber === undefined || phoneNumber === null) {
        return '';
    }

    const phoneStr = phoneNumber.toString();
    if (phoneStr.length === 0) {
        return '';
    }

    if (!phoneRegex.test(phoneStr)) {
        return 'You must enter a valid phone number or leave field blank.';
    }

    return '';
}

export const validatePassword = (password) => {
    if (!isNewPasswordLength(password))
        return `${NEW_PASSWORD_LENGTH_MESSAGE} Or leave it blank.`;

    return '';
}

export const validateConfirmPassword = (password, confirmPassword) => {
    if (!isNewPasswordLength(confirmPassword))
        return NEW_PASSWORD_LENGTH_MESSAGE;

    if (password !== confirmPassword && confirmPassword.length > 0)
        return 'The password and confirmPassword fields are not equal.'

    return '';
}

export const validatePasswordProfile = (password) => {
    if (password && !isNewPasswordLength(password))
        return NEW_PASSWORD_LENGTH_MESSAGE;

    return '';
}

export const validateConfirmPasswordProfile = (password, confirmPassword) => {
    if (confirmPassword && !isNewPasswordLength(confirmPassword))
        return NEW_PASSWORD_LENGTH_MESSAGE;

    if (password !== confirmPassword && confirmPassword.length > 0)
        return 'The password and confirmPassword fields are not equal.'

    return '';
}
